export const availabelUrls = ['/brands', '/profile'];
